import { Injectable, Injector } from '@angular/core';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { EmployerAmount } from '../entities/employer-amount';

@Injectable()
export class EmployerAmountService extends BaseCrudService<EmployerAmount> {

  public uri = '/api/employerAmount/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EmployerAmountService');
  }

  buildSentence(entity?: EmployerAmount, event?: LazyLoadEvent): HttpParams {
    if (entity) {
        let query = '';
        query = query.concat(
          entity.contribution ?
            `contribution${QueryOperator.Contain}${entity.contribution}${QueryOperator.Split}`
            : QueryOperator.Empty
        );

      if (entity.employerContribution && entity.employerContribution.id) {
        query = query.concat(
          'employerContribution.id' + QueryOperator.Equal + entity.employerContribution.id + QueryOperator.Split
        );
      }
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          'executingUnit.id' + QueryOperator.Equal + entity.executingUnit.id + QueryOperator.Split
        );
      }
      if (entity.payrollType && entity.payrollType.id) {
        query = query.concat(
          'payrollType.id' + QueryOperator.Equal + entity.payrollType.id + QueryOperator.Split
        );
      }
      if (entity.employeeType && entity.employeeType.id) {
        query = query.concat(
          'employeeType.id' + QueryOperator.Equal + entity.employeeType.id + QueryOperator.Split
        );
      }
      if (entity.month && entity.month.id) {
        query = query.concat(
          'month.id' + QueryOperator.Equal + entity.month.id + QueryOperator.Split
        );
      }
      if (entity.employee && entity.employee.id) {
        query = query.concat(
          'employee.id' + QueryOperator.Equal + entity.employee.id + QueryOperator.Split
        );
      }
      if (entity.fiscalYear && entity.fiscalYear.id) {
        query = query.concat(
          'fiscalYear.id' + QueryOperator.Equal + entity.fiscalYear.id + QueryOperator.Split
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/employer-amount.service.ts